import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgWallet = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19.031 4.125a.843.843 0 1 1 0 1.688H6.094c-.777 0-1.407.63-1.407 1.406v9.562c0 .777.63 1.407 1.407 1.407h11.812c.777 0 1.407-.63 1.407-1.407v-6.187c0-.777-.63-1.406-1.407-1.406H7.22a.84.84 0 0 1-.844-.844c0-.468.376-.844.844-.844h10.687A3.094 3.094 0 0 1 21 10.594v6.187a3.094 3.094 0 0 1-3.094 3.094H6.094A3.094 3.094 0 0 1 3 16.781V7.22a3.094 3.094 0 0 1 3.094-3.094zm-3.656 9.563c0-.623.503-1.126 1.125-1.126s1.125.503 1.125 1.126-.503 1.124-1.125 1.124a1.124 1.124 0 0 1-1.125-1.124"
    }));
export default SvgWallet;
